import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Breadcrumbs, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import styled from "styled-components";

// Styled breadcrumb container to center the breadcrumbs
const BreadcrumbContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4;
  margin-bottom: 10px;
`;

// StyledBreadcrumb for individual breadcrumb items
const StyledBreadcrumb = styled.li`
  display: inline-flex;
  align-items: center;
  padding: 5px 1px;
  background-color: #f4f4f4;
  border-radius: 4px;
`;

// StyledLink for breadcrumb links
const StyledLink = styled(Link)`
  font-family: ${window.ENV.FONT_FAMILY || 'UP-Book, sans-serif'};
  text-decoration: none;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  font-weight: 500;
  display: inline-flex;
  align-items: center;
`;

// Wrapper for HomeIcon to align it properly
const HomeIconWrapper = styled.span`
  display: flex;
  align-items: center;
  vertical-align: middle;
  margin-right: 2px;
`;

const AppBreadcrumbs = ({ categoryName }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const dataKey = window.ENV.GOOGLE_SHEET_ID;
  const API_URL = process.env.REACT_APP_API_URL;
const url = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/data`;
  const requestBody = {
    range: "Category!A1:G300",
    dataKey: dataKey,
    filters: {
      categoryName: [categoryName],
    },
  };

  useEffect(() => {
    if (categoryName !== "root") {
      axios
        .post(url, requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("API Response:", response.data);
          setData(response.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          const errorMessage = error.response
            ? error.response.data.message
            : error.message;
          setError(
            errorMessage || "An error occurred while fetching the data."
          );
        });
    }
  }, [categoryName]);
  if (categoryName === "root") {
    return null;
  }

  // Initialize breadcrumbs with "Home"
  let crumbs = [
    <StyledBreadcrumb key="home">
      <StyledLink to="/">
        <HomeIconWrapper>
          <HomeIcon style={{ fontSize: "19px" }} />
        </HomeIconWrapper>
        {/* <span>Categories</span> */}
      </StyledLink>
    </StyledBreadcrumb>,
  ];

  // Add breadcrumbs dynamically based on `data[0]?.path`
  const pathString = data?.[0]?.categoryNamePath || "";
  const pathLabel = data?.[0]?.categoryLabelPath || "";
  const pathSegments = pathString.split(",");
  const pathLabelArray = pathLabel.split(",");
  pathSegments.forEach((segment, index) => {
    let basePath = "";
    if (pathSegments.length > 1 &&  index < pathSegments.length - 1) {
      basePath = "/category"; 
    } else {
      basePath = data?.[0]?.isLeaf === "y" ? "/productlist" : "/category"; // Determine base path
    }
   
    const path = `${basePath}/${segment}`; // Construct the full path
    crumbs.push(
      <StyledBreadcrumb key={segment}>
        <StyledLink to={path}>
          {decodeURIComponent(pathLabelArray[index])}
        </StyledLink>
      </StyledBreadcrumb>
    );
  });

  return (
    <BreadcrumbContainer>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <Breadcrumbs aria-label="breadcrumb">{crumbs}</Breadcrumbs>
    </BreadcrumbContainer>
  );
};

export default AppBreadcrumbs;
